import _ from 'lodash';
import React, { useEffect, useState  } from 'react';
import { Button, Container, Label, Search, Segment, Grid, Header } from 'semantic-ui-react'
import { searchBuyersData, getLoginLink as _getLoginLink } from '../../services/Manager'

const TIMEOUT = 500;
var searchTimout = undefined;
const ImpersonateBuyer = () => {
    
    const [selectedUser, setSelectedUser] = useState({});
    const [searchPhrase, setSearchPhrase] = useState('');
    const [selectedValue, setSelectedValue] = useState('');
    const [users, setUsers] = useState([]);
    const [loginLink, setLoginLink] = useState('');

    useEffect(() => {
        if(searchPhrase.length >= 3){
            if(searchTimout){
                clearTimeout(searchTimout);
            }
            searchTimout = setTimeout(searchUser, TIMEOUT);
            
        }
        
    }, [searchPhrase])
    
    const onSearchChange = (e, data) => {
        
        setSearchPhrase(data.value);
        setSelectedValue(data.value);
    }

    const searchUser = async () => {
        if(!_.isEmpty(searchPhrase) && searchPhrase.length >= 3){
            const usersResponse = await searchBuyersData(searchPhrase);
            if(usersResponse.resStatus == 200){
                setUsers(usersResponse.data);
            }
        }
    }

    const onResultSelect = (e, data) => {
        setSelectedValue(data.result.first);
        setSelectedUser(data.result);
        setLoginLink('');
        
    }

    const resultRenderer = ({firstName, lastName, isBuyer, email, first}) => {
        return [<div key={`content`} className='content'>
            {first} &nbsp;
            {<Label color="blue">Buyer</Label>}
        </div>,
        <div className='description'>{email}</div>]
    }


    const onLoginAsBuyer = async () => {
        const usersResponse = await _getLoginLink(selectedUser.userID);
        if(usersResponse.resStatus == 200){
            const link = usersResponse.data.link;
            if (link){
                window.open(link);
            }
        }        
    }

    const getLoginLink = async () => {
        const usersResponse = await _getLoginLink(selectedUser.userID);
        setLoginLink(usersResponse.data.link);
    }
    return <>
    <Container className="user-container" fluid>
            <Segment className="filter-segment">
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Header>Search Buyer</Header>
                            <Search
                                fluid
                                minCharacters={3}
                                onSearchChange={onSearchChange}
                                results={users}
                                resultRenderer={resultRenderer}
                                onResultSelect={onResultSelect}
                                value={selectedValue}
                                className="seller-search search-box"
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
      
        {!_.isEmpty(selectedUser) &&
            <Segment className='selected-user-segment'>
                <div className="name-bar">
                    <div className="user-name">
                        {`${selectedUser.first}`} &nbsp;&nbsp;
                        {selectedUser.isBuyer && <Label color="blue">Buyer</Label>}
                    </div>

                </div>
                <div>
                    <div className="user-email">{selectedUser.email}</div>
                </div>
                <br />
                <div>
                    {
                        !_.isEmpty(selectedUser) &&
                        <>
                            <Button onClick={onLoginAsBuyer}>Login As {selectedUser.first}</Button>
                            <Button onClick={getLoginLink}>Get Login Link</Button>
                            {loginLink}
                        </>
                    }
                </div>

            </Segment>
        }

    </Container>
    </>

}
export default ImpersonateBuyer;